import { SuccessComponent } from './success/success.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SignalsComponent } from '../items/signals/signals.component';
import { ForexComponent } from './signals/forex.component';
import { TradingComponent } from '../items/trading/trading.component';
import { MarketingComponent } from '../items/marketing/marketing.component';
import { EducationComponent } from '../items/education/education.component';
import { SharedModule } from '../../shared/shared.module';
import { ITEMS_ROUTES } from './items.routes';
import { ItemsComponent } from './items.component';
import { PagesModule } from '../pages.module';
import { EventsComponent } from './events/events.component';
import { OnebetComponent } from './onebet/onebet.component';
import { RecommendedComponent } from './recommended/recommended.component';
import { ServicesItemsComponent } from './services-items/services-items.component';


@NgModule({
    declarations: [
        ItemsComponent,
        SignalsComponent,
        ForexComponent,
        TradingComponent,
        MarketingComponent,
        EducationComponent,
        EventsComponent,
        RecommendedComponent,
        SuccessComponent,
        OnebetComponent,
        ServicesItemsComponent

    ],
    exports: [

    ],
    imports: [
    BrowserModule,
        SharedModule,
        PagesModule,
        ITEMS_ROUTES,
        FormsModule,
        ReactiveFormsModule
    ],
})

export class ItemsModule { }
